import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { change as formChange } from 'redux-form';

import * as CssClassNames from 'src/constants/CssClassNames';
import { Section } from 'jbc-front/components/Form';
import scrollSpy, { AnchorTarget } from 'jbc-front/components/ScrollSpy';
import FormErrors, { LabelMapper } from 'src/jbc-front/components/FormErrors';
import Affix from 'jbc-front/components/Affix';
import ListGroup from 'jbc-front/components/ListGroup';
import { Anchor, ErrorsSection } from 'src/components';
import { FormSubmitBtn, CancelBtn } from 'src/buttons';
import { getSelectOptions, setOptions } from 'src/reducers/selectOptions';
import selector from 'src/utils/Utils';
import { getEmployeeFormValues } from 'src/reducers/employees/employees';
import { EMPLOYEE_FORM } from 'src/constants/FormNames';
import { useTranslation } from 'react-i18next';
import { ProfileImage } from 'src/components/ProfileImage';
import { imageType } from 'src/utils/Form';
import { User } from 'jbc-front/components/icons';
import { getCurrentUserInfo, isRoleTypeAdmin } from 'src/reducers/users/currentUser';

import BasicInfoSection from './BasicInfoSection';
import EmployeeRemarks from './EmployeeRemarks';
import BanksSection from '../containers/BanksSectionContainer';
import BusinessInfoSection from './BusinessInfoSection';
import PayrollRuleSection from './PayrollRuleSection';
import EmployeeAllowancesSection from './EmployeeAllowancesSection';
import EmployeeUnitPricesSection from './EmployeeUnitPricesSection';
// @TODO: Hide Provident Fund for Vietnam - comment out unused import
// https://donuts-vn.atlassian.net/browse/JBC-25
// import EmployeeProvidentFundSection from '../containers/EmployeeProvidentFundSectionContainer';
import IncomeTaxAndSSCSection from './IncomeTaxAndSSCSection';
import SocialSecurityContributionSection from './SocialSecurityContributionSection';
import styles from './EmployeeEditingForm.scss';
import PaymentBankSectionContainer from '../containers/PaymentBankSectionContainer';
import EmployeeMotivation from './EmployeeMotivation';
import ProbationSetting from './ProbationSetting';
import UnionDuesContributionSection from './UnionDuesContributionSection';

const DetailEmployeeForm = ({
  showEmployeeUrl,
  submitting,
  submit,
  handleSubmit,
  errors,
  anyJobRunning,
  pristine,
  initialValues,
  dispatch,
  currentUser
}) => {
  const { t } = useTranslation();
  useEffect(
    () => {
      dispatch(
        setOptions({
          clientProvidentFunds: initialValues.clientProvidentFunds,
          client: initialValues.client,
          clientBranch: initialValues.clientBranch
        })
      );
    },
    [initialValues.clientProvidentFunds, initialValues.client, initialValues.clientBranch, dispatch]
  );

  return (
    <form className={classNames(CssClassNames.FORM, CssClassNames.EMPLOYEE_FORM, styles.form)} onSubmit={handleSubmit}>
      <ErrorsSection errors={errors} />
      <FormErrors />

      <AnchorTarget name="BasicInfomation" />
      <Section title={t('features.Employees.showEmployee.basic_information')}>
        <LabelMapper name="employee" label=" " />
        <BasicInfoSection />
      </Section>

      <AnchorTarget name="EmploymentInfomation" />
      <Section title={t('features.Employees.showEmployee.business_information')}>
        <LabelMapper name="employee" label=" " />
        <LabelMapper
          name="employeeLeaveOfAbsences"
          label={t('features.Employees.components.EmployeeEditingForm.Leave_of_absense_period')}
        />
        <BusinessInfoSection />
      </Section>

      <AnchorTarget name="RemunerationInfomation" />
      <Section title={t('features.Employees.showEmployee.salary')}>
        <LabelMapper name="employeePayrollRule" label={t('features.Employees.components.EmployeeEditingForm.Salary_rule_group')} />
        <PayrollRuleSection />
        {isRoleTypeAdmin(currentUser.roleType) && (
          <React.Fragment>
            <LabelMapper
              name="employeeAllowances"
              label={t('features.Employees.components.EmployeeEditingForm.Salarys_provision_and_deduction_setting')}
            />
            <EmployeeAllowancesSection />
            <LabelMapper
              name="employeeUnitPrices"
              label={t('features.Employees.components.EmployeeEditingForm.Salarys_unit_price_setting')}
            />
            <EmployeeUnitPricesSection />
            <LabelMapper name="isCalculateMotivation" label={t('features.Employees.components.EmployeeEditingForm.motivation_setting')} />
            <EmployeeMotivation />
          </React.Fragment>
        )}
      </Section>

      <AnchorTarget name="ProbationSetting" />
      <Section title={t('features.Employees.components.ProbationSetting.probation_setting')}>
        <LabelMapper name="probationSetting" label={t('features.Employees.components.EmployeeEditingForm.probation_setting')} />
        <ProbationSetting />
      </Section>

      {/* @TODO: Hide Provident Fund for Vietnam */}
      {/* https://donuts-vn.atlassian.net/browse/JBC-25 */}
      {/*
      <AnchorTarget name="ProvidentFundInformation" />
      <Section title={t('features.Employees.components.ProvidentFundSection.provident_fund_setting')}>
        <LabelMapper name="employeeProvidentFunds" label={t('features.Employees.components.EmployeeEditingForm.provident_fund')} />
        <EmployeeProvidentFundSection />
      </Section>
    */}

      {/* <AnchorTarget name="CommutingAllowanceInfomation" />
      <Section title={t('features.Employees.showEmployee.commuting_allowance')}>
        <LabelMapper name="employeeCommutings" label="通勤手当の" />
        <CommutingsSection />
      </Section> */}

      <AnchorTarget name="BankInfomation" />
      <Section title={t('features.Employees.showEmployee.bank_account_information')}>
        <LabelMapper name="employeeBanks" label={t('features.Employees.components.EmployeeEditingForm.Account_information')} />
        <BanksSection />
      </Section>

      <AnchorTarget name="PaymentBankSection" />
      <Section title={t('features.Employees.showEmployee.payment_setting')}>
        <LabelMapper name="payPaymentBanks" label={t('features.Employees.components.EmployeeEditingForm.Provision_setting_salary')} />
        {/* <LabelMapper name="bonusPaymentBanks" label="支給設定：賞与の" /> */}
        <PaymentBankSectionContainer />
      </Section>

      <AnchorTarget name="SocialSecurityContributionSection" />
      <Section title={t('features.Employees.showEmployee.social_security_contribution')}>
        <LabelMapper name="socialSecurityContribution" label={t('features.Employees.components.EmployeeEditingForm.social_security_setting')} />
        <SocialSecurityContributionSection />
        <UnionDuesContributionSection />
      </Section>
      {/* <AnchorTarget name="Dependent" /> */}
      {/* <Section title={t('features.Employees.showEmployee.dependent_information')}> */}
      {/* <LabelMapper name="employeeFamilySupports" label="扶養情報の" /> */}
      {/* <FamilySupportsSection inputedSupports={inputedSupports} /> */}
      {/* </Section> */}

      {/* <AnchorTarget name="Marital" />
      <Section title={t('features.Employees.showEmployee.spouse_information')}>
        <MaritalStatusSection />
      </Section> */}

      {/* <AnchorTarget name="PersonalType" />
      <Section title={t('features.Employees.showEmployee.tax_class_information')}>
        <LabelMapper name="employeeTaxClassification" label="税区分情報の" />
        <TaxClassificationSection />
      </Section> */}

      <AnchorTarget name="IncomeTaxAndSSCSection" />
      <Section title={t('features.Employees.showEmployee.tax_calculation_setting')}>
        <LabelMapper name="IncomeTaxAndSSCSection" label={'IncomeTaxAndSSCSection'} />
        <IncomeTaxAndSSCSection />
      </Section>

      <AnchorTarget name="Remarks" />
      <Section title={t('features.Employees.showEmployee.remarks')}>
        <LabelMapper name="Remarks" label={t('features.Employees.components.EmployeeEditingForm.remarks')} />
        <EmployeeRemarks />
      </Section>

      <div className="u-ta-c">
        <CancelBtn href={showEmployeeUrl} className="u-mr20" />
        <FormSubmitBtn
          {...{ submitting, submit }}
          text={t('features.EmployeeBonus.components.ActionButtonSection.save')}
          disabled={anyJobRunning || submitting || pristine}
          disabledReason={
            anyJobRunning
              ? t('features.Employees.components.EmployeeEditingForm.Cannot_edit_because_employee_information_is_being_updated_via_CSV')
              : null
          }
        />
      </div>
    </form>
  );
};

const EmployeeEditingForm = scrollSpy(
  ({ naviSubmit, current, submitting, pristine, submit, anyJobRunning, inputedSupports, dispatch, image, currentUser, ...rest }) => {
    const { t } = useTranslation();

    const uploadImage = async data => {
      if (data !== undefined) {
        dispatch(formChange(EMPLOYEE_FORM, 'employee.profileImage', data));
      }
    };
    const removeImage = () => {
      dispatch(formChange(EMPLOYEE_FORM, 'employee.profileImage', null));
    };

    return (
      <div>
        <div className="l-flex">
          <div className="l-flex6-sub">
            <Affix offset={271} className={styles.navi}>
              <ProfileImage
                edit
                name="employeeImage"
                image={imageType(image)}
                uploadImage={data => uploadImage(data)}
                defaultImage={<User size={200} />}
                removeImage={removeImage}
              />
              <ListGroup>
                <Anchor name="BasicInfomation" current={current}>
                  {t('features.Employees.showEmployee.basic_information')}
                </Anchor>
                <Anchor name="EmploymentInfomation" current={current}>
                  {t('features.Employees.showEmployee.business_information')}
                </Anchor>
                <Anchor name="RemunerationInfomation" current={current}>
                  {t('features.Employees.showEmployee.salary')}
                </Anchor>
                {/* <Anchor name="CommutingAllowanceInfomation" current={current}>
                  {t('features.Employees.showEmployee.commuting_allowance')}
                </Anchor> */}
                <Anchor name="ProbationSetting" current={current}>
                  {t('features.Employees.showEmployee.probation_setting')}
                </Anchor>
                {/* @TODO: Hide Provident Fund for Vietnam */}
                {/* https://donuts-vn.atlassian.net/browse/JBC-25 */}
                {/*
                <Anchor name="ProvidentFundInformation" current={current}>
                  {t('features.Clients.ShowClient.provident_fund_setting')}
                </Anchor>
                */}
                <Anchor name="BankInfomation" current={current}>
                  {t('features.Employees.showEmployee.bank_account_information')}
                </Anchor>
                <Anchor name="PaymentBankSection" current={current}>
                  {t('features.Employees.showEmployee.payment_setting')}
                </Anchor>
                {/* <Anchor name="Dependent" current={current}>
                  {t('features.Employees.showEmployee.dependent_information')}
                </Anchor> */}
                {/* <Anchor name="TaxCalculation" current={current}>
                  {t('features.Employees.showEmployee.spouse_information')}
                </Anchor> */}
                <Anchor name="SocialSecurityContributionSection" current={current}>
                  {t('features.Employees.showEmployee.social_security_contribution')}
                </Anchor>

                <Anchor name="IncomeTaxAndSSCSection" current={current}>
                  {t('features.Employees.showEmployee.tax_calculation_setting')}
                </Anchor>
                <Anchor name="Remarks" current={current}>
                  {t('features.Employees.showEmployee.remarks')}
                </Anchor>
                {/* <Anchor name="PersonalType" current={current}>
                  {t('features.Employees.showEmployee.tax_class_information')}
                </Anchor> */}
                {/* <Anchor name="InhabitantTax" current={current}>
                  住民税
                </Anchor> */}
                {/* <Anchor name="SocialInsuranceInfomation" current={current}>
                  {t('features.Employees.showEmployee.social_insurance')}
                </Anchor> */}
                <ListGroup.Item>
                  <FormSubmitBtn
                    {...{ submitting, submit }}
                    text={t('features.EmployeeBonus.components.ActionButtonSection.save')}
                    widthWide
                    disabled={anyJobRunning || submitting || pristine}
                    disabledReason={
                      anyJobRunning
                        ? t(
                            'features.Employees.components.EmployeeEditingForm.Cannot_edit_because_employee_information_is_being_updated_via_CSV'
                          )
                        : null
                    }
                  />
                </ListGroup.Item>
              </ListGroup>
            </Affix>
          </div>
          <div className="l-flex6-main">
            <DetailEmployeeForm {...{ submitting, submit, anyJobRunning, inputedSupports, currentUser, pristine, dispatch }} {...rest} />
          </div>
        </div>
      </div>
    );
  }
);

const mapStateToProps = state => ({
  anyJobRunning: getSelectOptions(state, 'anyJobRunning'),
  inputedSupports: selector(getEmployeeFormValues(state), 'employeeFamilySupports'),
  image: getEmployeeFormValues(state).employee.profileImage,
  currentUser: getCurrentUserInfo(state) || {}
});

export default connect(mapStateToProps)(EmployeeEditingForm);
